<template>
    <div :class="['absolute top-0 left-0 right-0 m-auto w-full', fullBorder ? 'px-4 lg:px-0' : 'px-4' ]">
        <div class="border-b border-gray-200 w-full"></div>
    </div>
</template>

<script>
    export default {
        props: ['fullBorder']
    }
</script>
